import styled from '@emotion/styled';
import { rgba } from 'polished';


export const Wrapper = styled.div`
    display: inline-flex;
    align-items: center;
`;


export const Switch = styled.label`
    display: inline-block;
    width: 2.5625rem;
    height: 1.375rem;
    position: relative;

    .switch {
        width: 2.5625rem;
        height: 1.375rem;
        position: absolute;
        top: 0;
        background-color: ${({ theme }) => theme.greys[50]};
        border-radius: 1rem;
        transition: background 0.4s ease;

        &:hover {
            cursor: pointer;
        }

        &:before {
            position: absolute;
            content: '';
            width: 1.125rem;
            height: 1.125rem;
            background-color: ${({ theme }) => theme.colors.white};
            box-shadow: 0 5px 20px ${({ theme }) => rgba(theme.colors.dark, 0.1)};
            position: absolute;
            top: 0.125rem;
            left: 0.125rem;
            border-radius: 0.5625rem;
            transition: left 0.3s ease;
        }
    }

    input {
        opacity: 0;
        width: 0;
        height: 0;

        &:checked + .switch {
            background-color: ${({ theme }) => theme.colors.primary};

            &:before {
                left: 1.3125rem;
            }
        }
    }
`;

export const Label = styled.span`
    padding-left: 1rem;
    display: block;
    font-size: .9rem;
    width: 100%;
`;
